import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor() { }

  logInfo(logData: any) {
    if (environment.name != 'production') {
    }

  }
}
